import { ModelBase } from '@barthauer/abc/core/data';

export class AsciiWizardTransferObject {
  settingDocument: AsciiWizardSettingDocument;
  shapeFileZipped: File;
  constructor() {}
}

export interface AsciiWizardSettingDocument {
  id: string;
  name?: string;
}

export class AsciiImportQueryModel extends ModelBase {
  BCEDocumentId?: string;
  ShapezipfileAsBase64?: string;

  constructor() {
    super();
  }
}
